import { Flex, VStack, Heading, useToast, Button } from "@chakra-ui/react";
import { OlaggModule, PermissionEnum } from "@olagg/db-types";
import { useEffect, useState } from "react";
import useRoles from "../../../../features/Roles/hooks/useRoles";
import { useForm, FormProvider } from 'react-hook-form'
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import {
    fetcher,
    AdminUserPreferencesEndpoints
} from '@olagg/api-hooks'
import OlaggFormInput from "../../../../components/Forms/OlaggFormInput";
import { UserPreferencesStrings } from '../../types'

type FormData = {
    name: string,
    label: string,
    extra_data: extraDataAttributes,
    image: string,
}

type extraDataAttributes = {
    en: {
        name: string,
        label: string
    },
    pt: {
        name: string,
        label: string
    }
}

const schema: Yup.Schema<FormData> = Yup
    .object({
        name: Yup.string().required('El Nombre es obligatorio'),
        label: Yup.string().required('El label es obligatorio'),
        image: Yup.string().required('URL de la imagen es obligatoria'),
        extra_data: Yup.object({
            en: Yup.object({
                name: Yup.string().optional().nullable(),
                label: Yup.string().optional().nullable(),
            }),
            pt: Yup.object({
                name: Yup.string().optional().nullable(),
                label: Yup.string().optional().nullable(),
            })
        })
    })
    .required()

const UserPreferencesForm = ({
    tabIndex,
    selectedPreference
}: {
    tabIndex: number,
    selectedPreference: string
}) => {

    const { missingPermission } = useRoles();
    const toast = useToast()
    const [isLoading, setIsLoading] = useState(false)

    const useFormMethods = useForm<FormData>({
        resolver: yupResolver(schema),
        mode: 'onChange',
    });

    const errors = useFormMethods.formState.errors;

    useEffect(() => {
        console.log(errors);
        
    }, [errors])

    const onSubmit = (dataForm) => {
        let payload = { gamingPlatform: dataForm }
        setIsLoading(true)
        fetcher(AdminUserPreferencesEndpoints[selectedPreference].new(payload))
            .then(() => {
                toast({
                    title: 'Preferencia de Usuario creada',
                    colorScheme: 'olaggPink',
                    status: 'success',
                    label: '',
                    position: 'bottom-right'
                })
                //LIMPAR FORM
                useFormMethods.reset()
                setIsLoading(false)
            })
            .catch(e => {
                toast({
                    title: 'Error',
                    colorScheme: 'olaggYellow',
                    status: 'error',
                    label: e?.error?.message,
                    position: 'bottom-right'
                })
                setIsLoading(false)
            })
    }

    return (
        <Flex w={'full'} py={'15px'} pb={4} minH='600px' justifyContent='center'>
            <VStack color={'white'} w={'full'} maxW={'60%'}>
                <Flex flexDirection="column" w={'full'}>
                    <Heading fontSize={'30px'}>Cargar {UserPreferencesStrings[selectedPreference]}</Heading>
                </Flex>

                <Flex w={'full'} flexDirection='column'>

                    <Flex position={'relative'} zIndex='0' mt={'20px'}>
                        <FormProvider {...useFormMethods}>
                            <form onSubmit={useFormMethods.handleSubmit(onSubmit)} style={{ width: '100%' }}>

                                <OlaggFormInput
                                    required={true}
                                    label='Nombre en Español'
                                    controlName='name'
                                    placeholder='Nombre en español'
                                    customStyles={{
                                        fontWeight: '700'
                                    }}
                                />

                                <Flex direction='column' w='full' bgColor='#20173d' p='8' mb={'40px'} borderRadius={'12px'}>

                                    <OlaggFormInput
                                        required={true}
                                        label='Nombre en Inglés'
                                        controlName='extra_data.en.name'
                                        placeholder='Nombre en inglés'
                                        customStyles={{
                                            fontWeight: '700'
                                        }}
                                    />

                                    <OlaggFormInput
                                        required={true}
                                        label='Nombre en Portugués'
                                        controlName='extra_data.pt.name'
                                        placeholder='Nombre en portugués'
                                        customStyles={{
                                            fontWeight: '700'
                                        }}
                                    />

                                </Flex>

                                <OlaggFormInput
                                    required={true}
                                    label='Label en Español'
                                    controlName='label'
                                    placeholder='Label en español'
                                    customStyles={{
                                        fontWeight: '700'
                                    }}
                                />

                                <Flex direction='column' w='full' bgColor='#20173d' p='8' mb={'40px'} borderRadius={'12px'}>

                                    <OlaggFormInput
                                        required={true}
                                        label='Label en Inglés'
                                        controlName='extra_data.en.label'
                                        placeholder='Label en inglés'
                                        customStyles={{
                                            fontWeight: '700'
                                        }}
                                    />

                                    <OlaggFormInput
                                        required={true}
                                        label='Label en Portugués'
                                        controlName='extra_data.pt.label'
                                        placeholder='Label en portugués'
                                        customStyles={{
                                            fontWeight: '700'
                                        }}
                                    />

                                </Flex>

                                <OlaggFormInput
                                    required={true}
                                    label='URL Image'
                                    controlName='image'
                                    placeholder='URL de la imagen'
                                    customStyles={{
                                        fontWeight: '700'
                                    }}
                                />

                                <Button
                                    variant={'filledGradient'}
                                    isLoading={isLoading}
                                    type="submit"
                                    w={'full'}
                                    style={{
                                        marginTop: '30px'
                                    }}
                                    isDisabled={isLoading || missingPermission(OlaggModule.GamingPlatform, PermissionEnum.CREATE)}
                                >
                                    Cargar Nuevo
                                </Button>
                            </form>
                        </FormProvider>
                    </Flex>
                </Flex>
            </VStack >
        </Flex >
    )
};

export default UserPreferencesForm;
